<style scoped lang="scss">
.order-mgmt-content-div {
    height: 100vh;
    background-color: rgb(242 242 242) !important;
}

.order-mgmt-card {
    background-color: white;
    padding: 2rem;
    margin: 1.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.order-mgmt-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #409EFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.filter-bar {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
}

.order-mgmt-table {
    width: 100%;
}

.order-info-cell {
    .order-id-row {
        font-size: 0.8rem;
        color: #94a3b8;
        margin-bottom: 0.2rem;
    }

    .goods-name-row {
        font-size: 0.9rem;
        font-weight: 600;
        color: #1e293b;
        margin-bottom: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .amount-row {
        font-size: 0.95rem;
        font-weight: 700;
        color: #e6a23c;
    }
}

.auth-info-cell {
    .auth-row {
        font-size: 0.82rem;
        line-height: 1.7;
        color: #475569;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .auth-label {
        color: #94a3b8;
        margin-right: 0.4rem;
        flex-shrink: 0;
    }
}

.pagination {
    margin: 1.5rem auto 0;
    width: fit-content;
}

@media screen and (max-width: 768px) {
    .order-mgmt-card {
        margin: 1rem;
        padding: 1.2rem;
    }
}
</style>

<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <UserHeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;height: 100vh;overflow: auto;padding-left: 0;background-color: rgb(242, 242, 242) !important;">
                    <div class="order-mgmt-content-div">
                        <div class="order-mgmt-card">
                            <div class="order-mgmt-title">
                                <span>订单管理</span>
                            </div>

                            <!-- 筛选栏 -->
                            <div class="filter-bar">
                                <el-select v-model="filterStatus" placeholder="订单状态" clearable style="width: 140px"
                                    @change="handleFilter">
                                    <el-option :value="0" label="待支付" />
                                    <el-option :value="1" label="已完成" />
                                    <el-option :value="2" label="已取消" />
                                </el-select>
                                <el-input v-model="filterOrderId" placeholder="搜索订单号" clearable style="width: 220px"
                                    @clear="handleFilter" @keyup.enter="handleFilter" />
                                <el-button type="primary" @click="handleFilter">查询</el-button>
                                <el-button @click="resetFilter">重置</el-button>
                            </div>

                            <el-table :data="orderList" class="order-mgmt-table" v-loading="loading">
                                <el-table-column label="订单信息" min-width="260">
                                    <template #default="scope">
                                        <div class="order-info-cell">
                                            <div class="order-id-row">{{ scope.row.order_id }}</div>
                                            <div class="goods-name-row">{{ scope.row.goods_name }}</div>
                                            <div class="amount-row">￥{{ scope.row.amount }}</div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="quantity" label="数量" width="70" />
                                <el-table-column prop="status" label="状态" width="90">
                                    <template #default="scope">
                                        <el-tag :type="statusTagType(scope.row.status)" size="small">
                                            {{ scope.row.status_text || statusText(scope.row.status) }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="pay_mode" label="支付模式" width="100">
                                    <template #default="scope">
                                        <el-tag size="small" effect="plain">
                                            {{ scope.row.pay_mode === 'tenant' ? '自定义收款' : '系统收款' }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="授权信息" min-width="220">
                                    <template #default="scope">
                                        <div class="auth-info-cell">
                                            <div class="auth-row">
                                                <span class="auth-label">邮箱</span>
                                                <span>{{ scope.row.email || '-' }}</span>
                                            </div>
                                            <div class="auth-row">
                                                <span class="auth-label">授权</span>
                                                <span>{{ scope.row.auth_value || '-' }}</span>
                                            </div>
                                            <div class="auth-row">
                                                <span class="auth-label">结果</span>
                                                <span>{{ scope.row.auth_result || '-' }}</span>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="created_at" label="下单时间" width="170" />
                                <el-table-column label="操作" width="220" fixed="right">
                                    <template #default="scope">
                                        <el-button size="small" @click="openDetailDialog(scope.row)">详情</el-button>
                                        <el-button size="small" type="warning" v-if="scope.row.status === 0"
                                            @click="openEditDialog(scope.row)">修改</el-button>
                                        <el-button size="small" type="success"
                                            v-if="scope.row.status === 0 && scope.row.pay_mode === 'tenant'"
                                            @click="markPaid(scope.row)">标记已付</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div class="pagination">
                                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                                    :total="total" :page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next"
                                    @size-change="getOrderList" @current-change="getOrderList" />
                            </div>
                        </div>
                    </div>

                    <!-- 订单详情弹窗 -->
                    <el-dialog v-model="detailDialogVisible" title="订单详情" width="600px">
                        <el-descriptions :column="1" border>
                            <el-descriptions-item label="订单号">{{ currentOrder.order_id }}</el-descriptions-item>
                            <el-descriptions-item label="商品名称">{{ currentOrder.goods_name }}</el-descriptions-item>
                            <el-descriptions-item label="订单金额">￥{{ currentOrder.amount }}</el-descriptions-item>
                            <el-descriptions-item label="购买数量">{{ currentOrder.quantity }}</el-descriptions-item>
                            <el-descriptions-item label="订单状态">
                                <el-tag :type="statusTagType(currentOrder.status)" size="small">
                                    {{ currentOrder.status_text || statusText(currentOrder.status) }}
                                </el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="支付模式">
                                {{ currentOrder.pay_mode === 'tenant' ? '自定义收款' : '系统收款' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="支付渠道">{{ currentOrder.pay_type }}</el-descriptions-item>
                            <el-descriptions-item label="下单邮箱">{{ currentOrder.email }}</el-descriptions-item>
                            <el-descriptions-item label="授权字段">{{ currentOrder.auth_value }}</el-descriptions-item>
                            <el-descriptions-item label="授权结果">{{ currentOrder.auth_result || '-'
                                }}</el-descriptions-item>
                            <el-descriptions-item label="查询密码">{{ currentOrder.query_password }}</el-descriptions-item>
                            <el-descriptions-item label="下单时间">{{ currentOrder.created_at }}</el-descriptions-item>
                            <el-descriptions-item label="支付时间">{{ currentOrder.paid_at || '-' }}</el-descriptions-item>
                        </el-descriptions>
                        <template #footer>
                            <el-button @click="detailDialogVisible = false">关闭</el-button>
                        </template>
                    </el-dialog>

                    <!-- 修改订单弹窗 -->
                    <el-dialog v-model="editDialogVisible" title="修改订单" width="500px">
                        <el-form :model="editForm" label-width="100px">
                            <el-form-item label="订单号">
                                <el-input :model-value="editForm.order_id" disabled />
                            </el-form-item>
                            <el-form-item label="授权字段">
                                <el-input v-model="editForm.auth_value" placeholder="请输入授权字段值" />
                            </el-form-item>
                            <el-form-item label="下单邮箱">
                                <el-input v-model="editForm.email" placeholder="请输入邮箱" />
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <el-button @click="editDialogVisible = false">取消</el-button>
                            <el-button type="primary" @click="submitEdit" :loading="submitting">确认修改</el-button>
                        </template>
                    </el-dialog>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const orderList = ref<any[]>([])
const loading = ref(false)
const currentPage = ref(1)
const pageSize = ref(20)
const total = ref(0)
const filterStatus = ref<number | ''>('')
const filterOrderId = ref('')

// 详情弹窗
const detailDialogVisible = ref(false)
const currentOrder = ref<any>({})

// 修改弹窗
const editDialogVisible = ref(false)
const editForm = ref({
    order_id: '',
    auth_value: '',
    email: '',
})
const submitting = ref(false)

const statusText = (status: number) => {
    const map: Record<number, string> = { 0: '待支付', 1: '已完成', 2: '已取消' }
    return map[status] || '未知'
}

const statusTagType = (status: number) => {
    const map: Record<number, string> = { 0: 'warning', 1: 'success', 2: 'info' }
    return map[status] || 'info'
}

const getOrderList = async () => {
    loading.value = true
    try {
        const params: any = {
            page: currentPage.value,
            pageSize: pageSize.value,
        }
        if (filterStatus.value !== '') {
            params.status = filterStatus.value
        }
        if (filterOrderId.value) {
            params.order_id = filterOrderId.value
        }
        const res = await axios.post(baseURL + '/api/shop/tenant/order/list', params, { headers })
        if (res.data.code === 0) {
            const data = res.data.data
            orderList.value = data.list || []
            total.value = data.total || 0
        } else {
            ElMessage.error(res.data.msg || '获取订单列表失败')
        }
    } catch (e: any) {
        ElMessage.error('获取订单列表失败：' + e.message)
    } finally {
        loading.value = false
    }
}

const handleFilter = () => {
    currentPage.value = 1
    getOrderList()
}

const resetFilter = () => {
    filterStatus.value = ''
    filterOrderId.value = ''
    currentPage.value = 1
    getOrderList()
}

const openDetailDialog = (row: any) => {
    currentOrder.value = { ...row }
    detailDialogVisible.value = true
}

const openEditDialog = (row: any) => {
    editForm.value = {
        order_id: row.order_id,
        auth_value: row.auth_value || '',
        email: row.email || '',
    }
    editDialogVisible.value = true
}

const submitEdit = async () => {
    submitting.value = true
    try {
        const payload: any = { order_id: editForm.value.order_id }
        if (editForm.value.auth_value) payload.auth_value = editForm.value.auth_value
        if (editForm.value.email) payload.email = editForm.value.email
        const res = await axios.post(baseURL + '/api/shop/tenant/order/update', payload, { headers })
        if (res.data.code === 0) {
            ElMessage.success('修改成功')
            editDialogVisible.value = false
            getOrderList()
        } else {
            ElMessage.error(res.data.msg || '修改失败')
        }
    } catch (e: any) {
        ElMessage.error('修改失败：' + e.message)
    } finally {
        submitting.value = false
    }
}

const markPaid = (row: any) => {
    ElMessageBox.confirm(
        `确认将订单「${row.order_id}」标记为已支付吗？\n标记后系统将执行扣款、授权、反利等逻辑，此操作不可撤销。`,
        '确认标记已支付',
        {
            confirmButtonText: '确认标记',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(async () => {
        try {
            const res = await axios.post(baseURL + '/api/shop/tenant/order/markPaid', { order_id: row.order_id }, { headers })
            if (res.data.code === 0) {
                ElMessage.success('订单已标记为已支付')
                getOrderList()
            } else {
                ElMessage.error(res.data.msg || '操作失败')
            }
        } catch (e: any) {
            ElMessage.error('操作失败：' + e.message)
        }
    }).catch(() => { /* 取消 */ })
}

onMounted(() => {
    getOrderList()
})
</script>
